"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var TableCell = _styledComponents.default.td.withConfig({
  displayName: "ProductCatalogTableCell__TableCell",
  componentId: "dv0g6w-0"
})(["height:40px;padding:10px 20px;width:18.75%;min-width:175px;text-align:center !important;p{margin:0;}line-height:14px;"]);

var ProductCatalogModalTableCell = function ProductCatalogModalTableCell(_ref) {
  var feature = _ref.feature,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip;
  var cellContent = null;

  if (feature) {
    if (feature.shortLimitKey) {
      var shortLimitContent = _react.default.createElement("div", null, _react.default.createElement(_Small.default, {
        style: showTooltip && feature.longLimitKey ? {
          cursor: 'help'
        } : {}
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "pricing-pages.shortLimits." + feature.shortLimitKey
      })), feature.isNew && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("br", null), _react.default.createElement(_UIBadge.default, {
        use: "new"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "pricingPage.new"
      }))));

      cellContent = feature.longLimitKey ? _react.default.createElement(_UITooltip.default, {
        use: "longform",
        placement: "left",
        disabled: !showTooltip,
        title: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "pricing-pages.fullLimits." + feature.longLimitKey
        })
      }, shortLimitContent) : shortLimitContent;
    } else {
      cellContent = _react.default.createElement(_UIIcon.default, {
        name: "success",
        size: "small"
      });
    }
  }

  return _react.default.createElement(TableCell, null, cellContent);
};

ProductCatalogModalTableCell.propTypes = {
  feature: _propTypes.default.shape({
    shortLimitKey: _propTypes.default.string,
    longLimitKey: _propTypes.default.string,
    isNew: _propTypes.default.bool
  }),
  showTooltip: _propTypes.default.bool
};
var _default = ProductCatalogModalTableCell;
exports.default = _default;
module.exports = exports.default;